import type { ActiveAnalysis } from "../api/useActiveAnalysesStream";
import type { FailureValueStatus, IndexedFailureMetadata } from "../api/useFailureMetadata";
import type { IndexedFailureValues } from "../api/useIndexedFailureValues";
import type { IndexedManualFailureValues } from "../api/useManualFailureValues";
import computeInternalGap from "./computeInternalGap";

export default function computeUnexplainedGap(
  analysis: ActiveAnalysis,
  indexedFailureValues: IndexedFailureValues,
  indexedFailureMetadata: IndexedFailureMetadata,
  indexedManualFailureValues: IndexedManualFailureValues,
  quantityId: string,
  status: Set<FailureValueStatus>,
  offset: number,
): number | null {
  const internalGap = computeInternalGap(analysis, quantityId, offset);
  if (internalGap === null) return null;

  const failureValues = indexedFailureValues[analysis.date];
  if (failureValues === undefined) return internalGap;

  let impact = 0;
  for (const failureName in failureValues) {
    const fv = failureValues[failureName];
    if (fv === undefined) throw new Error("Unexpected undefined failureValue");

    if (status.has(indexedFailureMetadata.getFailureStatus(fv.date, fv.failureName)))
      impact += fv.impacts[quantityId] ?? 0;
  }

  const manualFailureValues = indexedManualFailureValues[analysis.id];
  if (manualFailureValues)
    for (const mfvId in manualFailureValues)
      impact += manualFailureValues[mfvId]?.impacts[quantityId] ?? 0;

  return internalGap - impact;
}
